export default __webpack_public_path__ + "static/ETH-logo-1055606e7cdedf346573057d586024d7.svg";